import { Component, OnInit } from '@angular/core';
import {ConfService} from '../conf.service';
import {MatSnackBar} from '@angular/material';
import {SettingsComponent} from '../settings/settings.component';
import {AppComponent} from '../app.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
class ImageSnippet {
  constructor(public src: string, public file: File) {
  }
}
@Component({
  selector: 'app-resume-parser',
  templateUrl: './resume-parser.component.html',
  styleUrls: ['./resume-parser.component.scss']
})

export class ResumeParserComponent implements OnInit {
  items: any;
  selectedFile: ImageSnippet;
  fileName = '';
  folder = '';
  extracedData = {};
  extracedDataForResume = [];
  annotateField = [];
  candidateModel = [];

  lineLabel = [];
    loading = false;
    s3URL: string;
    loading2 = false;
    error = true;
    error2 = true;
    isAnnotateOnlyAndTrain = true;
    isAnnotateOnly = true;
  lineLables = [];
  returnJson = [];
  isUploadedSuccessfully = false;
  isTrainedSuccessfully = true;
    industryType: any;
    extractDataFromResumeRetries = 0;

  constructor(
      private cfgSrv: ConfService, public platform: LeftpanelComponent, private confPost: ConfService, public settingComp: SettingsComponent, private appComp: AppComponent
  ) { }

  ngOnInit() {
      this.appComp.currentPageTitle = 'Resume Parser';
      this.appComp.ribbon = 'Resume Parser';
      if (!this.settingComp.item) {
          this.settingComp.setcolumnvalues();
      }
      this.confPost.getIndustryType().subscribe(response => {
          this.industryType = response;
      });
      // this.annotateField = ['', 'firstName', 'middleName', 'lastName', 'gender', 'image', 'about', 'DOB', 'industry', 'phoneNumber', 'emailId', 'address.addressLine1', 'address.addressLine2', 'address.city', 'address.state', 'address.country', 'currency', 'education.school', 'education.degree', 'education.fieldOfStudy', 'education.startYear', 'education.endYear', 'education.gradeType', 'education.grade', 'experience.company', 'experience.jobTitle', 'experience.jobFunction', 'experience.employmentType', 'experience.location', 'experience.currentlyWorking', 'experience.startDate.month', 'experience.startDate.year', 'experience.endDate.month', 'experience.endDate.year', 'languages.name', 'languages.proficiency', 'skills', 'interests', 'publications.title', 'publications.publication', 'publications.publicationType', 'publications.publicationDate', 'publications.authors', 'publications.publicationURL', 'publications.description', 'publications.associatedWith', 'patents.title', 'patents.patentOffice', 'patents.applicationNumber', 'patents.inventors', 'patents.status', 'patents.issueDate', 'patents.patentURL', 'patents.description', 'patents.associatedWith', 'testScores.testName', 'testScores.scoreObtained', 'testScores.maximumScore', 'testScores.scoreType', 'testScores.testDate.month', 'testScores.testDate.year', 'testScores.description', 'projects.title', 'projects.currentlyWorking', 'projects.startDate.month', 'projects.startDate.year', 'projects.endDate.month', 'projects.endDate.year', 'projects.creators', 'projects.projectURL', 'projects.description', 'projects.associatedWith', 'honorsAndAwards.title', 'honorsAndAwards.issuer', 'honorsAndAwards.issueDate.month', 'honorsAndAwards.issueDate.year', 'honorsAndAwards.level', 'honorsAndAwards.description', 'organizations.name', 'organizations.positionHeld', 'organizations.membershipOngoing', 'organizations.startDate.month', 'organizations.startDate.year', 'organizations.description', 'organizations.endDate.month', 'organizations.endDate.year', 'licensesAndCertifications.name', 'licensesAndCertifications.issuingOrganization', 'licensesAndCertifications.doesExpire', 'licensesAndCertifications.issueDate.month', 'licensesAndCertifications.issueDate.year', 'licensesAndCertifications.expirationDate.month', 'licensesAndCertifications.expirationDate.year', 'licensesAndCertifications.id', 'licensesAndCertifications.url', 'volunteerExperience.organization', 'volunteerExperience.role', 'volunteerExperience.currentlyVolunteering', 'volunteerExperience.description', 'volunteerExperience.startDate.month', 'volunteerExperience.startDate.year', 'volunteerExperience.endDate.month', 'volunteerExperience.endDate.year', 'socialMediaFootPrint.website', 'socialMediaFootPrint.linkedIn', 'socialMediaFootPrint.medium', 'endorsements.skillEndorsedFor', 'endorsements.endorsedBy.name', 'endorsements.endorsedBy.linkedIn', 'endorsements.endorsementText', 'attachments.title', 'attachments.description', 'attachments.url', 'currentCompensation.fixedCompensation', 'currentCompensation.variablePay', 'currentCompensation.incentives', 'currentCompensation.ESOP', 'expectedCompensation.fixedCompensation', 'expectedCompensation.variablePay', 'expectedCompensation.incentives', 'expectedCompensation.ESOP']
      this.annotateField = ['', 'firstName', 'middleName', 'lastName', 'gender', 'image', 'about', 'DOB', 'industry', 'phoneNumber', 'emailId', 'address.addressLine1', 'address.addressLine2', 'address.city', 'address.state', 'address.country', 'currency', 'education.school', 'education.degree', 'education.fieldOfStudy', 'education.startYear', 'education.endYear', 'education.gradeType', 'education.grade', 'experience.company', 'experience.jobTitle', 'experience.jobFunction', 'experience.employmentType', 'experience.location', 'experience.currentlyWorking', 'experience.startDate.month', 'experience.startDate.year', 'experience.endDate.month', 'experience.endDate.year', 'languages.name', 'languages.proficiency', 'skills', 'interests', 'publications.title', 'publications.publication', 'publications.publicationType', 'publications.publicationDate', 'publications.authors', 'publications.publicationURL', 'publications.description', 'publications.associatedWith', 'patents.title', 'patents.patentOffice', 'patents.applicationNumber', 'patents.inventors', 'patents.status', 'patents.issueDate', 'patents.patentURL', 'patents.description', 'patents.associatedWith', 'testScores.testName', 'testScores.scoreObtained', 'testScores.maximumScore', 'testScores.scoreType', 'testScores.testDate.month', 'testScores.testDate.year', 'testScores.description', 'projects.title', 'projects.currentlyWorking', 'projects.startDate.month', 'projects.startDate.year', 'projects.endDate.month', 'projects.endDate.year', 'projects.creators', 'projects.projectURL', 'projects.description', 'projects.associatedWith', 'honorsAndAwards.title', 'honorsAndAwards.issuer', 'honorsAndAwards.issueDate.month', 'honorsAndAwards.issueDate.year', 'honorsAndAwards.level', 'honorsAndAwards.description', 'organizations.name', 'organizations.positionHeld', 'organizations.membershipOngoing', 'organizations.startDate.month', 'organizations.startDate.year', 'organizations.description', 'organizations.endDate.month', 'organizations.endDate.year', 'licensesAndCertifications.name', 'licensesAndCertifications.issuingOrganization', 'licensesAndCertifications.doesExpire', 'licensesAndCertifications.issueDate.month', 'licensesAndCertifications.issueDate.year', 'licensesAndCertifications.expirationDate.month', 'licensesAndCertifications.expirationDate.year', 'licensesAndCertifications.id', 'licensesAndCertifications.url', 'volunteerExperience.organization', 'volunteerExperience.role', 'volunteerExperience.currentlyVolunteering', 'volunteerExperience.description', 'volunteerExperience.startDate.month', 'volunteerExperience.startDate.year', 'volunteerExperience.endDate.month', 'volunteerExperience.endDate.year', 'socialMediaFootPrint.website', 'socialMediaFootPrint.linkedIn', 'socialMediaFootPrint.medium', 'endorsements.skillEndorsedFor', 'endorsements.endorsedBy.name', 'endorsements.endorsedBy.linkedIn', 'endorsements.endorsementText', 'attachments.title', 'attachments.description', 'attachments.url', 'currentCompensation.fixedCompensation', 'currentCompensation.variablePay', 'currentCompensation.incentives', 'currentCompensation.ESOP', 'expectedCompensation.fixedCompensation', 'expectedCompensation.variablePay', 'expectedCompensation.incentives', 'expectedCompensation.ESOP', 'education.period', 'experience.period', 'projects.period', 'totalExperience']
      // this.extracedData = {
    //     "body": [
    //         [
    //             "Software Systems",
    //             "Clear Thinker and Open minded."
    //         ]
    //     ],
    //     "response": {
    //         "0": {
    //             "text": "Software Systems",
    //             "line_label": "firstName"
    //         },
    //         "1": {
    //             "text": "Clear Thinker and Open minded.",
    //             "line_label": "currency"
    //         }
    //     }
    // };
    //   this.isUploadedSuccessfully = true;
    // this.extracedDataForResume = this.extracedData['body'][0];
    // this.annotateField = [
    //     '',
    //     'firstName',
    //     'middleName',
    //     'lastName',
    //     'gender',
    //     'image',
    //     'about',
    //     'DOB',
    //     'industry',
    //     'phoneNumber',
    //     'emailId',
    //     'address',
    //     'addressAddressLine1',
    //     'addressAddressLine2',
    //     'addressCity',
    //     'addressState',
    //     'addressCountry',
    //     'currency',
    //     'education',
    //     'educationSchool',
    //     'educationDegree',
    //     'educationFieldOfStudy',
    //     'educationStartYear',
    //     'educationEndYear',
    //     'educationGradeType',
    //     'educationGrade',
    //     'experience',
    //     'experienceCompany',
    //     'experienceJobTitle',
    //     'experienceJobFunction',
    //     'experienceEmploymentType',
    //     'experienceLocation',
    //     'experienceCurrentlyWorking',
    //     'experienceStartDateMonth',
    //     'experienceStartDateYear',
    //     'experienceEndDateMonth',
    //     'experienceEndDateYear',
    //     'language',
    //     'languagesName',
    //     'languagesProficiency',
    //     'skills',
    //     'interests',
    //     'publications',
    //     'publicationsTitle',
    //     'publicationsPublication',
    //     'publicationsPublicationType',
    //     'publicationsPublicationDate',
    //     'publicationsAuthors',
    //     'publicationsPublicationURL',
    //     'publicationsDescription',
    //     'publicationsAssociatedWith',
    //     'patents',
    //     'patentsTitle',
    //     'patentsPatentOffice',
    //     'patentsApplicationNumber',
    //     'patentsInventors',
    //     'patentsStatus',
    //     'patentsIssueDate',
    //     'patentsPatentURL',
    //     'patentsDescription',
    //     'patentsAssociatedWith',
    //     'testScores',
    //     'testScoresTestName',
    //     'testScoresScoreObtained',
    //     'testScoresMaximumScore',
    //     'testScoresScoreType',
    //     'testScoresTestDateMonth',
    //     'testScoresTestDateYear',
    //     'testScoresDescription',
    //     'projects',
    //     'projectsTitle',
    //     'projectsCurrentlyWorking',
    //     'projectsStartDateMonth',
    //     'projectsStartDateYear',
    //     'projectsEndDateMonth',
    //     'projectsEndDateYear',
    //     'projectsCreators',
    //     'projectsProjectURL',
    //     'projectsDescription',
    //     'projectsAssociatedWith',
    //     'honorsAndAwards',
    //     'honorsAndAwardsTitle',
    //     'honorsAndAwardsIssuer',
    //     'honorsAndAwardsIssueDateMonth',
    //     'honorsAndAwardsIssueDateYear',
    //     'honorsAndAwardsLevel',
    //     'honorsAndAwardsDescription',
    //     'organizations',
    //     'organizationsName',
    //     'organizationsPositionHeld',
    //     'organizationsMembershipOngoing',
    //     'organizationsStartDateMonth',
    //     'organizationsStartDateYear',
    //     'organizationsDescription',
    //     'organizationsEndDateMonth',
    //     'organizationsEndDateYear',
    //     'licensesAndCertifications',
    //     'licensesAndCertificationsName',
    //     'licensesAndCertificationsIssuingOrganization',
    //     'licensesAndCertificationsDoesExpire',
    //     'licensesAndCertificationsIssueDateMonth',
    //     'licensesAndCertificationsIssueDateYear',
    //     'licensesAndCertificationsExpirationDateMonth',
    //     'licensesAndCertificationsExpirationDateYear',
    //     'licensesAndCertificationsId',
    //     'licensesAndCertificationsUrl',
    //     'volunteerExperience',
    //     'volunteerExperienceOrganization',
    //     'volunteerExperienceRole',
    //     'volunteerExperienceCurrentlyVolunteering',
    //     'volunteerExperienceDescription',
    //     'volunteerExperienceStartDateMonth',
    //     'volunteerExperienceStartDateYear',
    //     'volunteerExperienceEndDateMonth',
    //     'volunteerExperienceEndDateYear',
    //     'socialMediaFootPrint',
    //     'socialMediaFootPrintWebsite',
    //     'socialMediaFootPrintLinkedIn',
    //     'socialMediaFootPrintMedium',
    //     'endorsements',
    //     'endorsementsSkillEndorsedFor',
    //     'endorsementsEndorsedByName',
    //     'endorsementsEndorsedByLinkedIn',
    //     'endorsementsEndorsementText',
    //     'attachments',
    //     'attachmentsTitle',
    //     'attachmentsDescription',
    //     'attachmentsUrl',
    //     'currentCompensation',
    //     'currentCompensationFixedCompensation',
    //     'currentCompensationVariablePay',
    //     'currentCompensationIncentives',
    //     'currentCompensationESOP',
    //     'expectedCompensation',
    //     'expectedCompensationFixedCompensation',
    //     'expectedCompensationVariablePay',
    //     'expectedCompensationIncentives',
    //     'expectedCompensationESOP'
    // ];
      this.lineLables = ['header', 'content' , 'meta'];
  }
  addNew() {
      this.extracedDataForResume.push('');
      const lengthOfExtractedData = this.extracedDataForResume.length;
      this.extracedData['response'][lengthOfExtractedData - 1] = {'text' : '' , 'line_label' : '' , 'line_type' : '' };

  }
    removeNew(index){
        // this.extracedDataForResume.splice(index, 1);
        this.extracedDataForResume[index] = false;
        delete this.extracedData['response'][index];
    }

    extractDataFromResume(res) {
        this.confPost.extractDataFromResume(localStorage.getItem('partner'), res, localStorage.getItem('partnerKey')).subscribe(
            (response) => {
                this.extracedData = response;
                this.extracedDataForResume = this.extracedData['body'][0];
                this.isUploadedSuccessfully = true;
                this.loading  = false;
            },
            (err) => {
                this.extractDataFromResumeRetries += 1;
                if (this.extractDataFromResumeRetries <= 5) {
                    setTimeout(() => {
                        this.extractDataFromResume(res);
                    }, 5000);
                } else {
                    this.loading  = false;
                    this.platform.openSnackBar('Error occurred while upload, Please try after sometime', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            });
    }

  processFile(imageInput: any) {
      this.loading = true;
      this.error = false;
    const file: File = imageInput.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedFile = new ImageSnippet(event.target.result, file);

      this.confPost.uploadS3FileForResume(localStorage.getItem('account'), this.fileName, localStorage.getItem('partner'), this.selectedFile.file, this.folder).subscribe(
          (res) => {
            // this.extracedData = {
            //   "body": [
            //     [
            //       "Backend Developer with an year of experience in developing, deploying and maintaining Web",
            //       "Projects. Specialized in Spring Boot and MongoDB.",
            //       "Shashank Pal",
            //       "System Engineer",
            //       "WORK EXPERIENCE",
            //       "System Engineer",
            //       "Infosys",
            //       "07/2018 – Present",
            //       "Build and Deploy Backend features for a new age assessment platform.",
            //       "Create and Maintain various micro services to cater to platform needs.",
            //       "linkedin.com/in/palshashank",
            //       "Design and Build platform solutions using various AWS Oﬀerings to increase platform",
            //       "eﬃciency.",
            //       "Intern",
            //       "Infosys",
            //       "01/2018 – 05/2018",
            //       "Build an e-commerce solution using IBM WebSphere Commerce",
            //       "Improve Inventory Management using Struts and EJB",
            //       "Create micro services to improve buyers experience",
            //       "Flask",
            //       "Linux",
            //       "SQL",
            //       "PROJECTS",
            //       "Word Sense Disambiguation (09/2017 – 12/2017)",
            //       "Implemented an algorithmic solution to solve the open world problem of identifying which sense of a word",
            //       "is used in a sentence.",
            //       "Let's Buy (03/2018 – 05/2018)",
            //       "Created an online grocery store using IBM WebSphere Commerce suite for faster and streamlined buying",
            //       "experience.",
            //       "shashank.oﬃcial@outlook.com",
            //       "9792227827",
            //       "Mysore, India",
            //       "SKILLS",
            //       "Spring Boot",
            //       "Python",
            //       "MongoDB",
            //       "AWS",
            //       "Elastic search",
            //       "Nginx",
            //       "LANGUAGES",
            //       "English",
            //       "Full Professional Proﬁciency",
            //       "Hindi",
            //       "Native or Bilingual Proﬁciency",
            //       "INTERESTS",
            //       "Graphic Designing",
            //       "Exploring World War 2",
            //       "EDUCATION",
            //       "B. Tech",
            //       "Pranveer Singh Institute of Technology",
            //       "2014 – 2018",
            //       "Intermediate",
            //       "St. Basils",
            //       "2014",
            //       "High School",
            //       "St. Basils",
            //       "2012",
            //       "ACHIEVEMENTS",
            //       "Cleared TCS Codevita 2016 Round 2",
            //       "College Representative for CodeChef and IIT Bomaby",
            //       "Mysore",
            //       "Mysore",
            //       "76%",
            //       "81.2",
            //       "84.8"
            //     ]
            //   ]
            // }
            // this.extracedDataForResume = this.extracedData['body'][0];
              this.s3URL = res['s3URL'];
            this.extractDataFromResume(res);

          },
          (err) => {
              this.loading  = false;
            this.platform.openSnackBar('Error occurred while upload, Please try after sometime', 'Error', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
    });
    reader.readAsDataURL(file);
  }
    annotateFile() {
        this.isAnnotateOnlyAndTrain = false;
        this.loading2 = true;
        this.error2 = false;
        for (let i = 0 ; i < this.extracedDataForResume.length ; i++) {
            if (this.extracedDataForResume[i] !== false && this.extracedData['response'][i]['line_label'] !== '' && this.extracedData['response'][i]['line_type'] !== '' && this.extracedData['response'][i]['text'] !== '' && this.extracedData['response'][i]['text'] !== false && this.extracedData['response'][i].hasOwnProperty("industryType") && this.extracedData['response'][i].hasOwnProperty("isIndustry")&& this.extracedData['response'][i]["industryType"] !== undefined && this.extracedData['response'][i]["industryType"] !== '' && this.extracedData['response'][i]["isIndustry"] !== undefined && this.extracedData['response'][i]["isIndustry"] !== ''  ){
                this.returnJson.push({'text' : this.extracedData['response'][i]['text'] , 'annotate' : this.extracedData['response'][i]['line_label'], 'line_label': this.extracedData['response'][i]['line_type'], 'isIndustry' : this.extracedData['response'][i]['isIndustry'] , 'industryType' : this.extracedData['response'][i]['industryType']});
            }
            else if (this.extracedDataForResume[i] !== false && this.extracedData['response'][i]['line_label'] !== '' && this.extracedData['response'][i]['line_type'] !== '' && this.extracedData['response'][i]['text'] !== '' && this.extracedData['response'][i]['text'] !== false){
                this.returnJson.push({'text' : this.extracedData['response'][i]['text'] , 'annotate' : this.extracedData['response'][i]['line_label'], 'line_label': this.extracedData['response'][i]['line_type']});
            }
        }
        this.confPost.createAnnotateFileInS3(localStorage.getItem('partner'), this.returnJson, this.s3URL).subscribe(
            (res) => {
                this.loading2 = false;
                this.error2 = true;
                this.isAnnotateOnlyAndTrain = true;
                this.isAnnotateOnly = true;
                this.extracedDataForResume = [];
                this.extracedData['response'] = [];
                this.candidateModel = [];
                this.lineLabel = [];
                this.isUploadedSuccessfully = false;
                this.platform.openSnackBar('File Annotated and Successfully Uploaded successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            },
            (err) => {
                this.isAnnotateOnlyAndTrain = true;
                this.isAnnotateOnly = true;
                this.loading  = false;
                this.error2 = true;
                this.platform.openSnackBar('Error uploading the file. Please try again after sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
    }
  annotateFileAndTrainModel() {
      this.isAnnotateOnly = false;
      this.loading2 = true;
      this.error2 = false;
      for (let i = 0 ; i < this.extracedDataForResume.length ; i++) {
          if (this.extracedDataForResume[i] !== false && this.extracedData['response'][i]['line_label'] !== '' && this.extracedData['response'][i]['line_type'] !== '' && this.extracedData['response'][i]['text'] !== '' && this.extracedData['response'][i]['text'] !== false && this.extracedData['response'][i].hasOwnProperty("industryType") && this.extracedData['response'][i].hasOwnProperty("isIndustry")&& this.extracedData['response'][i]["industryType"] !== undefined && this.extracedData['response'][i]["industryType"] !== '' && this.extracedData['response'][i]["isIndustry"] !== undefined && this.extracedData['response'][i]["isIndustry"] !== ''  ){
              this.returnJson.push({'text' : this.extracedData['response'][i]['text'] , 'annotate' : this.extracedData['response'][i]['line_label'], 'line_label': this.extracedData['response'][i]['line_type'], 'isIndustry' : this.extracedData['response'][i]['isIndustry'] , 'industryType' : this.extracedData['response'][i]['industryType']});
          }
          else if (this.extracedDataForResume[i] !== false && this.extracedData['response'][i]['line_label'] !== '' && this.extracedData['response'][i]['line_type'] !== '' && this.extracedData['response'][i]['text'] !== '' && this.extracedData['response'][i]['text'] !== false){
              this.returnJson.push({'text' : this.extracedData['response'][i]['text'] , 'annotate' : this.extracedData['response'][i]['line_label'], 'line_label': this.extracedData['response'][i]['line_type']});
          }

      }
    this.confPost.createAnnotateFileInS3(localStorage.getItem('partner'), this.returnJson, this.s3URL).subscribe(
                (res) => {
                    this.confPost.getAWSCredentilasForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(
                        (awscredentials) => {
                            const data = {
                                'bucketName': localStorage.getItem('partner'),
                                'folderPath': 'resumes/training_data',
                                'files': ['https://linkzy.s3.amazonaws.com/resumes/training_data/1584684706dYuVlGMVQMmrl7i.txt'],
                                'accessKey': awscredentials['awsAccessKey'],
                                'secretKey': awscredentials['awsSecretKey'],
                                'binaryModelPath': 'resumes/binary_model'
                            };
                            this.confPost.trainDataForResume(localStorage.getItem('partner'), data, localStorage.getItem('partnerKey')).subscribe(
                                (response) => {
                                    this.loading2 = false;
                                    this.isAnnotateOnlyAndTrain = true;
                                    this.isAnnotateOnly = true;
                                    this.error2 = true;
                                    this.extracedDataForResume = [];
                                    this.extracedData['response'] = [];
                                    this.candidateModel = [];
                                    this.lineLabel = [];
                                    this.isUploadedSuccessfully = false;
                                    this.platform.openSnackBar('Model Trained Successfully successfully', 'Success', {
                                        duration: 2000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                },
                                (err) => {
                                    this.loading2 = false;
                                    this.isAnnotateOnlyAndTrain = true;
                                    this.isAnnotateOnly = true;
                                    this.error2 = true;
                                    this.extracedDataForResume = [];
                                    this.extracedData['response'] = [];
                                    this.candidateModel = [];
                                    this.lineLabel = [];
                                    this.isUploadedSuccessfully = false;
                                    // this.platform.openSnackBar('Error Training the Model. Please try again after sometime', 'Error', {
                                    //     duration: 5000,
                                    //     verticalPosition: 'top',
                                    //     horizontalPosition: 'center'
                                    // });
                                });
                        });

      });
  }

}
